<script setup>

</script>

<template>
  <div class="app">
<!--    <nav class="nav-menu">-->
<!--      <router-link to="/" class="nav-item">首页</router-link>-->
<!--      <router-link to="/about" class="nav-item">关于</router-link>-->
<!--      <router-link to="/user" class="nav-item">用户</router-link>-->
<!--    </nav>-->

    <router-view></router-view>
  </div>
</template>

<style lang="scss">
@import '@/assets/font/fonts.css';
.app {
  margin: 0 auto;
}

.nav-menu {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-item {
  text-decoration: none;
  color: #333;
  padding: 8px 16px;
  margin-right: 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #f0f0f0;
}

.nav-item.router-link-active {
  background-color: #4CAF50;
  color: white;
}

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
